
import { Fragment,useMemo,useState } from "react";
import RowTableUsers from './RowTableUsers.jsx'
import { useSelector } from 'react-redux'

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}



export default function VisibleRows(props){
	const [addGameVisible,setAddGameVisible]=useState({id:"",status:false});
	let {rows,order,orderBy,page,rowsPerPage,selected,setSelected,setOpen} = props;
	let filtro=useSelector(state=>state.usuario.userFilter);


  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

const visibleRows = useMemo(
    () =>
      [...rows]
      	.filter(ele=>{
      		if(
      			ele.nombre.toLowerCase().includes(filtro.toLowerCase())
      			|| ele.usuario.toLowerCase().includes(filtro.toLowerCase())
      			| ele.correo.toLowerCase().includes(filtro.toLowerCase())
      		){return true}
      	})
        .sort(getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage,rows,filtro],
  );

	return(
		<Fragment>
			{visibleRows.map((row, index) => {
                const isItemSelected = selected.includes(row.id);
                           

                return (
                  <RowTableUsers row={row} isItemSelected={isItemSelected} handleClick={handleClick} setAddGame={setAddGameVisible} setOpenNewGame={setOpen} labelId/ >
                );

              })}
		</Fragment>
	)
}